import defaultAttributes from '../defaultAttributes';

const Triangle = [
  'svg',
  defaultAttributes,
  [
    [
      'path',
      {
        d:
          'M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z',
      },
    ],
  ],
];

export default Triangle;
